import type { SVGProps } from 'react';

export default function MoneyPercentage(
  props: SVGProps<SVGSVGElement>,
): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.3 15.9507H6.75C5.64543 15.9507 4.75 15.0553 4.75 13.9507V7.45068C4.75 6.34611 5.64543 5.45068 6.75 5.45068H17.25C18.3546 5.45068 19.25 6.34611 19.25 7.45068V10.0002"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 10.7007C13.5 11.5291 12.8284 12.2007 12 12.2007C11.1716 12.2007 10.5 11.5291 10.5 10.7007C10.5 9.87226 11.1716 9.20068 12 9.20068C12.8284 9.20068 13.5 9.87226 13.5 10.7007Z"
        fill="currentColor"
      />
      <path
        d="M19.5625 15.6001C19.5625 17.402 18.1019 18.8626 16.3 18.8626C14.4982 18.8626 13.0375 17.402 13.0375 15.6001C13.0375 13.7983 14.4982 12.3376 16.3 12.3376C18.1019 12.3376 19.5625 13.7983 19.5625 15.6001Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M17.47 14.4751L15.22 16.7251" stroke="currentColor" />
      <ellipse
        cx="17.335"
        cy="16.8375"
        rx="0.495009"
        ry="0.494997"
        fill="currentColor"
      />
      <ellipse
        cx="15.355"
        cy="14.3624"
        rx="0.495009"
        ry="0.494997"
        fill="currentColor"
      />
    </svg>
  );
}
